module.exports = __webpack_public_path__ + "static/media/M011-account-noprivilege.e83071f4.svg";